module.exports = __webpack_public_path__ + "static/media/big1.87c06269.png";